import { Box, styled } from '@mui/material';
import { CurrencyCode } from 'further-types/lp/vehicle';
import Table from 'further-ui/components/Table';
import { CalendarDay, numberToCurrencyString } from 'further-ui/utils';
import React from 'react';

const ApportionmentWrapper = styled(Box)({
  width: '100%',
  maxWidth: '700px',
});

type Props = {
  currency: CurrencyCode;
  apportionmentPeriods: Array<{
    name: string;
    periodStartDate: CalendarDay;
    periodEndDate: CalendarDay;
    apportionmentPercentage: number;
    amountApportionedIncVatTcy: number;
  }>;
};

const ApportionmentSummary: React.FC<Props> = ({
  apportionmentPeriods,
  currency,
}) => {
  const rows = apportionmentPeriods.map((period, index) => ({
    id: index.toString(),
    ...period,
  }));

  return (
    <ApportionmentWrapper>
      <Table
        columns={[
          {
            label: 'Name',
            key: 'name',
          },
          {
            label: 'Period',
            key: 'period',
            render: (cell) =>
              `${cell.periodStartDate.toLocalDateLabel()} - ${cell.periodEndDate.toLocalDateLabel()}`,
          },
          {
            label: 'Apportionment',
            key: 'apportionmentPercentage',

            render: (cell) => `${cell.apportionmentPercentage}%`,
          },
          {
            label: 'Amount apportioned',
            key: 'amountApportionedIncVatTcy',

            render: (cell) =>
              numberToCurrencyString(cell.amountApportionedIncVatTcy, {
                currency,
              }),
          },
        ]}
        rows={rows ?? []}
      />
    </ApportionmentWrapper>
  );
};

export default ApportionmentSummary;
